exports.menuitemlist = () => {
  const List = [
    [
      "Dashboard",
      "New Customer",
      "New Booking",
      "All Bookings",
       "Offers",
       "Customers",
       "User Reset"
    ],
    [
      "dashboardpage",
      "custreg",   
      "NewTicketBooking",  
      "bookings",
      "offers",
      "customers",
      "resetuserpassword"
    ],
  ];
  return List;
};
